import React, { Component, useRef } from "react";
import IconButton from "material-ui/IconButton";
import LioWebRTC from "liowebrtc";
import "./Party.css";

class Party extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nick: this.props.nick,
      roomID: `neural-meet-${this.props.roomName}`,
      peers: [],
      mutedPeerIds: [],
      inRoom: false,
      muted: false,
      message: "",
      chatLog: [],
      scrollHeight: null,
      typing: false,
      typers: [],
      typingEllipsis: "...",
    };
    this.remoteVideos = {};
    this.scrollInterval = null;
    this.typingEllipsisInterval = null;
  }

  componentDidMount() {
    this.webrtc = new LioWebRTC({
      // The url for your signaling server
      url: "https://sm1.lio.app:443/",
      // The local video ref set within your render function
      localVideoEl: this.localVid,
      // Optional: nickname
      nick: this.state.nick,
      debug: true,
    });

    this.textBox.focus();
    this.createIntervals();

    this.addListeners();

    if (!this.props.iOS) {
      this.webrtc.startLocalVideo();
    } else {
      this.setState({ inRoom: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const pc = prevProps.windowColor;
    const c = this.props.windowColor;
    if (pc.r !== c.r || pc.g !== c.g || pc.b !== c.b) {
      this.webrtc.shout("windowColor", c);
    }
  }

  addListeners = () => {
    this.webrtc.on("videoAdded", this.addVideo);
    this.webrtc.on("videoRemoved", this.removeVideo);
    this.webrtc.on("readyToCall", this.readyToCall);
    this.webrtc.on("iceFailed", this.handleConnectionError);
    this.webrtc.on("connectivityError", this.handleConnectionError);
    this.webrtc.on("mute", this.handlePeerMute);
    this.webrtc.on("unmute", this.handlePeerUnmute);
    this.webrtc.on("receivedPeerData", this.handlePeerData);
    this.webrtc.on("channelOpen", this.handleChannelOpen);
    this.webrtc.on("localMediaError", (e) =>
      alert(
        `Local Media Error\n\n${e.toString()}\n\nDoes your browser allow camera and mic access?`
      )
    );
  };

  addVideo = (stream, peer) => {
    console.log("ADD VIDEO", stream);
    if (this.props.nick === peer.nick) {
      return;
    }
    this.setState({ peers: [...this.state.peers, peer] }, () => {
      this.webrtc.attachStream(stream, this.remoteVideos[peer.id]);
    });
  };

  removeVideo = (peer) => {
    this.setState({
      peers: this.state.peers.filter((p) => !p.closed),
    });
  };

  appendChat = (chatObj) => {
    this.msgBox.scrollTop = this.msgBox.scrollHeight;
    this.setState({
      chatLog: [...this.state.chatLog, chatObj],
      scrollHeight: this.msgBox.scrollHeight,
    });
  };

  removeTyper = (nick) =>
    this.setState({ typers: this.state.typers.filter((t) => t !== nick) });

  handleInput = (evt) => {
    if (this.state.message.length === 0) {
      this.setState({ typing: true, message: evt.target.value });
      this.webrtc.shout("typingChange", { typing: true });
      return;
    }
    if (evt.target.value.length === 0) {
      this.setState({ typing: false });
      this.webrtc.shout("typingChange", { typing: false });
    }
    this.setState({ message: evt.target.value });
  };

  handleSend = () => {
    this.msgBox.scrollTop = this.msgBox.scrollHeight;
    if (this.state.message.length === 0) return;
    const chatObj = {
      username: this.state.nick,
      payload: this.state.message,
    };
    this.webrtc.shout("chat", chatObj);
    this.setState({
      chatLog: [...this.state.chatLog, chatObj],
      message: "",
      typing: false,
    });
  };

  createIntervals = () => {
    this.scrollInterval = setInterval(() => {
      if (!this.msgBox) return;
      const sh = this.msgBox.scrollHeight;
      if (this.state.scrollHeight !== sh) {
        this.msgBox.scrollTop = this.msgBox.scrollHeight;
        this.setState({
          scrollHeight: this.msgBox.scrollHeight,
        });
      }
    }, 50);

    this.typingEllipsisInterval = setInterval(() => {
      if (this.state.typers.length >= 1) {
        this.setState({
          typingEllipsis: this.state.typingEllipsis.length > 2 ? ".." : "...",
        });
      }
    }, 1000);
  };

  handlePeerData = (type, data, peer) => {
    switch (type) {
      case "windowColor":
        peer.bColor = `rgba(${data.r}, ${data.g}, ${data.b}, ${data.a})`;
        this.setState({ roomCount: this.webrtc.getPeers().length });
        break;
      case "chat":
        this.appendChat(data);
        this.removeTyper(peer.nick);
        break;
      case "typingChange":
        if (data.typing && !this.state.typers.includes(peer.nick)) {
          this.setState({ typers: [...this.state.typers, peer.nick] });
        } else if (!data.typing) {
          this.removeTyper(peer.nick);
        }
        break;
      default:
        break;
    }
  };

  handleChannelOpen = () =>
    this.webrtc.shout("windowColor", this.props.windowColor);

  handleConnectionError = (peer) => {
    const pc = peer.pc;
    console.log("had local relay candidate", pc.hadLocalRelayCandidate);
    console.log("had remote relay candidate", pc.hadRemoteRelayCandidate);
  };

  handleSelfMute = (e) => {
    const muted = this.state.muted;
    if (muted) {
      this.webrtc.unmute();
    } else {
      this.webrtc.mute();
    }
    this.setState({ muted: !muted });
  };

  handlePeerMute = (data) => {
    if (!this.state.mutedPeerIds.includes(data.id)) {
      this.setState({ mutedPeerIds: [...this.state.mutedPeerIds, data.id] });
    }
  };

  handlePeerUnmute = (data) => {
    this.setState({
      mutedPeerIds: this.state.mutedPeerIds.filter((id) => id !== data.id),
    });
  };

  handleVideoStart = () => {
    this.props.handleStartVideo();
    this.webrtc.startLocalVideo();
  };

  handleOverlayHover = (e) => {
    if (!e.target.className.includes("overlay ")) return;
    clearTimeout(e.target.overlayTimeout);
    for (const child of e.target.children) {
      child.style.visibility = "visible";
    }
    e.target.style.opacity = 1;
    this.setOverlayTimeout(e.target);
  };

  setOverlayTimeout = (tgt) =>
    (tgt.overlayTimeout = setTimeout(() => {
      if (!tgt || this.props.iOS) return;
      tgt.style.opacity = 0;
      for (const child of tgt.children) {
        child.style.visibility = "hidden";
      }
    }, 1000));

  readyToCall = () => {
    // Starts the process of joining a room.
    this.webrtc.joinRoom(this.state.roomID, (err, desc) => {
      this.setState({ inRoom: true });
    });
  };

  // Show fellow peers in the room
  generateRemotes = () =>
    this.state.peers.map((p) => (
      <div key={p.id}>
        <div
          className="vidContainer"
          style={{ borderColor: p.bColor }}
          id={
            /* The video container needs a special id */ `${this.webrtc.getContainerId(
              p
            )}`
          }
        >
          <video
            // Important: The video element needs both an id and ref
            id={this.webrtc.getId(p)}
            ref={(v) => (this.remoteVideos[p.id] = v)}
            playsInline
          />
          <div
            className={`overlay ${
              this.state.mutedPeerIds.includes(p.id) ? "visible" : ""
            }`}
            onMouseMove={this.handleOverlayHover}
            onTouchEnd={this.handleOverlayHover}
          >
            <div className="overlayBottom">
              {this.state.mutedPeerIds.includes(p.id) && (
                <i className="material-icons">volume_off</i>
              )}
            </div>
          </div>
        </div>
        <p>{p.nick}</p>
      </div>
    ));

  generateChats = () =>
    this.state.chatLog.map((chat, idx) => {
      return (
        <li key={`${idx}`} className="chatItem">
          {chat.username && (
            <p>
              <b className="chatUserName">{chat.username}: </b>
              {`${chat.payload}`}
            </p>
          )}
          {chat.notification && <p>{chat.payload}</p>}
        </li>
      );
    });

  disconnect = () => {
    this.webrtc.stopLocalVideo();
    this.webrtc.leaveRoom();
    this.webrtc.disconnect();
  };

  componentWillUnmount() {
    this.disconnect();
    clearInterval(this.scrollInterval);
    clearInterval(this.typingEllipsisInterval);
  }

  render() {
    const { windowColor } = this.props;

    return (
      <React.Fragment>
        <div
          className={this.state.inRoom ? "inRoom" : "wrapper"}
          ref={(e) => (this.wrapper = e)}
        >
          <div>
            <div
              className="vidContainer"
              style={{
                borderColor: `rgba(${windowColor.r}, ${windowColor.g}, ${windowColor.b}, ${windowColor.a})`,
              }}
            >
              <video
                // Important: The local video element needs to have a ref
                ref={(vid) => {
                  this.localVid = vid;
                }}
                playsInline
                muted
              />
              <div
                className={`overlay ${
                  this.state.muted || this.props.iOS ? "visible" : ""
                }`}
                onMouseMove={this.handleOverlayHover}
                onTouchEnd={this.handleOverlayHover}
                ref={(el) => (this.localOverlay = el)}
              >
                <div className="overlayMiddle">
                  {this.props.iOS && (
                    <IconButton
                      tooltip="Start Video"
                      onClick={this.handleVideoStart}
                    >
                      <i className="material-icons">video_call</i>
                    </IconButton>
                  )}
                  {!this.props.iOS && (
                    <IconButton
                      tooltip={this.state.muted ? "Unmute" : "Mute"}
                      onClick={this.handleSelfMute}
                    >
                      <i className="material-icons">
                        {this.state.muted ? "volume_off" : "volume_up"}
                      </i>
                    </IconButton>
                  )}
                </div>
              </div>
            </div>
            <p>{this.state.nick}</p>
          </div>
          {this.generateRemotes()}
        </div>
        {this.state.typers.length > 0 && (
          <p className="subText">
            {this.state.typers.length === 1
              ? `${this.state.typers[0]}${this.state.typingEllipsis}`
              : `${this.state.typingEllipsis}`}
          </p>
        )}
        <div className="messageBox" ref={(el) => (this.msgBox = el)}>
          {this.generateChats()}
        </div>
        <div className="controls">
          <input
            type="text"
            className="textBox chatInput"
            placeholder="Type a message..."
            ref={(t) => (this.textBox = t)}
            onChange={this.handleInput}
            value={this.state.message}
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                this.handleSend();
              }
            }}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default Party;



// WEBPACK FOOTER //
// ./src/components/Party/index.js